import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class OverlayService {
  public showEvent: EventEmitter<string> = new EventEmitter<string>();
  public hideEvent: EventEmitter<any> = new EventEmitter<any>();
  public setMessageEvent: EventEmitter<string> = new EventEmitter<string>();

  constructor() {}

  public show(message?: string) {
    this.showEvent.emit(message);
  }

  public setMessage(message: string) {
    this.setMessageEvent.emit(message);
  }

  public hide() {
    this.hideEvent.emit();
  }
}
